import React from 'react';
import TaskFileCardView from '../view/TaskFileCardView';
import fetchAPI from '../../../utils/fetchAPI';

const TaskFileCardEngine = ({
  displayFilename,
  encodedFilename,
  filename,
  onFileDeleted = () => {},
  size,
  taskId,
  viewOnly
}) => {
  const downloadUrl =
    process.env.REACT_APP_API_BASE +
    `/tasks/v1/files/tasks/${taskId}/${encodedFilename}`;

  const onClickedDelete = () => {
    fetchAPI(`/tasks/v1/eu/tasks/${taskId}/upload/${encodedFilename}`, {
      method: 'DELETE'
    })
      .then(() => {
        onFileDeleted(filename);
      })
      .catch(() => {
        onFileDeleted(false);
      });
  };

  const viewProps = {
    onClickedDelete,
    displayFilename,
    downloadUrl,
    filename,
    size,
    viewOnly
  };

  return <TaskFileCardView {...viewProps} />;
};

export default TaskFileCardEngine;
